jQuery(document).ready(function($) {
  // Wait a bit for dynamic content to load
  setTimeout(function() {
    var $popup = $('#shopify-block-ASTZkK3ZFTGY3VWZDO__boost_ai_search_filter_predictive_bundle_mJpnBL '),
        $addToCartBtn = $('buy-buttons button.button.anchor_button').first();

    console.log('Popup found:', $popup.length);
    console.log('Button found:', $addToCartBtn.length);

    if (!$popup.length || !$addToCartBtn.length) {
      console.warn('Popup or Add to Cart button not found.');
      return;
    }

     if (!$popup.find('.popup-close-btn').length) {
      console.log("checking for pop-up btn");
      var closeButton = `
        <button type="button" class="popup-close-btn" aria-label="Close popup">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L18 18M2 18L18 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      `;
      $(".boost-sd__recommendation").prepend(closeButton);
    }

    // Force hide with inline style
    $popup.css({'display': 'none', 'visibility': 'hidden'});

    function performAddToCart() {
      var $form = $addToCartBtn.closest('form');
      console.log('Performing add to cart');
      if ($form.length) {
        $form[0].submit(); // Use native submit
      } else {
        $addToCartBtn[0].click(); // Use native click
      }
    }

    $addToCartBtn.on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Button clicked - showing popup');
      $popup.css({'display': 'block', 'visibility': 'visible'});
      jQuery("div#boost-sd-dynamic-bundle-bundle-717150").show();
      jQuery("div#boost-sd-dynamic-bundle-bundle-717150").css('display','block');
    });

    // Close button handler
    $popup.on('click', '.close, .close-btn, [data-close], button[type="button"]', function(e) {
      e.preventDefault();
      console.log('Popup close button clicked');
      $popup.css({'display': 'none', 'visibility': 'hidden'});
      performAddToCart();
    });

    // Click outside handler
    $(document).on('click', function(e) {
      if ($popup.is(':visible') && 
          !$popup.is(e.target) && 
          $popup.has(e.target).length === 0 &&
          !$addToCartBtn.is(e.target) &&
          $addToCartBtn.has(e.target).length === 0) {
        console.log('Click outside popup');
        $popup.css({'display': 'none', 'visibility': 'hidden'});
        performAddToCart();
      }
    });

      $("button.boost-sd__recommendation-bundle-button.boost-sd__btn-add-to-cart").click(function(){
    
      console.log("testing for the bundle click");
      //bundle add to cart button
      setTimeout(function(){

           window.location.href = '/cart'
      },1000)

  });


  }, 1000); // Wait 500ms for content to load



});